export default function(items: string[]): number[] {
    const uniqueItems = new Set<string>();
    const res: number[] = [];

    items.forEach((item, i) => {
        if (!uniqueItems.has(item)) {
            return;
        }

        uniqueItems.add(item);
        res.push(i);
    });

    return res;
}
